import React from "react";

import {
  MapMarkerDisplayTypeEnum,
  MapMarkerLocationTypeEnum,
} from "@/custom-types/StoreLocator";

import { MarkerBadge, MarkerCircle, MarkerPin } from "./MarkerShapes";

type Props = {
  displayType: MapMarkerDisplayTypeEnum;
  locationType: MapMarkerLocationTypeEnum | null;
  imageLoaded?: boolean;
};

type SubcomponentProps = {
  locationType: MapMarkerLocationTypeEnum | null;
  imageLoaded?: boolean;
};

function ProminentImageContainerMarker() {
  return <MarkerPin fill="#FFCD00" stroke="#FFF" strokeWidth={2} />;
}

function ImageContainerMarker({
  imageLoaded,
  locationType,
}: SubcomponentProps) {
  switch (locationType) {
    case MapMarkerLocationTypeEnum.Delivery:
      return (
        <>
          <MarkerCircle fill={imageLoaded ? "#333" : "#017c6b"} />
          {imageLoaded && <MarkerBadge iconHref="#marker-icon-delivery" />}
        </>
      );
    default:
      return <MarkerCircle />;
  }
}

function ProminentIconMarker() {
  return <MarkerPin />;
}

function IconMarker() {
  return <MarkerCircle fill="#81a39c" />;
}

export default function DynamicMarker({
  displayType,
  imageLoaded = false,
  locationType = null,
}: Props) {
  switch (displayType) {
    case MapMarkerDisplayTypeEnum.ProminentImageContainer:
      return <ProminentImageContainerMarker />;
    case MapMarkerDisplayTypeEnum.ImageContainer:
      return (
        <ImageContainerMarker
          imageLoaded={imageLoaded}
          locationType={locationType}
        />
      );
    case MapMarkerDisplayTypeEnum.ProminentIcon:
      return <ProminentIconMarker />;
    default:
      return <IconMarker />;
  }
}
